export const ConcreteStructureTypes = {
  Beam: "Beam",
  BeamSimple: "Beam.SimpleSupported",
  BeamContinuous: "Beam.Continuous",
  Column: "Column",
  Slab: "Slab",
  Wall: "Wall"
};